import React from 'react';
import { ArrowRight } from 'lucide-react';
import { SAAS_SIGNUP_URL } from './saasContent';

const SaasCtaButton = ({
  label = 'Activate Your Growth Flywheel',
  className = '',
  showArrow = true,
}) => (
  <a
    href={SAAS_SIGNUP_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={`inline-flex items-center justify-center gap-2 h-12 md:h-14 px-8 md:px-10 lg:px-14 rounded-full bg-[#8ae690] text-black font-semibold text-sm md:text-base shadow-md hover:bg-[#7ad67f] hover:shadow-lg transition-all duration-200 ${className}`}
  >
    <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white/70">
      <img src="/kolanut_logo.png" alt="Kolanut logo" className="w-4 h-4 object-contain" />
    </span>
    {label}
    {showArrow ? <ArrowRight className="h-4 w-4" aria-hidden /> : null}
  </a>
);

export default SaasCtaButton;
